import React, { useRef } from "react"
import Container from "../../atoms/Container"
import styled from "styled-components"
import { Composition, useResponsiveValue, query } from "atomic-layout"
import Button from "../../atoms/Button"
import Image from "../../organisms/Image"
import { gap } from "../../../utils/spacing"

const StyledContainer = styled(Container)`
  //overflow: hidden;
  p {
    font-size: var(--callout-text-size);
  }
`

const StyledContent = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  min-height: auto;
  @media ${query({from: "lg"})}{
    min-height: 540px;
  }
`

const StyledImage = styled.div`
position: relative;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

const StyledAngles = styled.div`
  position: absolute;
  bottom: 30px;
  @media ${query({from: "md"})}{
    bottom: 80px;
  }
  @media ${query({from: "xl"})}{
    bottom: 40px;
  }
  right: 0;
  width: 100%;
  display: flex;
`

const StyledGoldenAngle = styled.div`
  position: absolute;
  right: 80px;
  background-color: #C69214;
  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);
  width: 65%;
  height: 40px;
`

const StyledBlueAngle = styled.div`
  position: absolute;
  right: 0px;
  top: -20px;
  background-color: #003057;
  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);
  width: 35%;
  height: 40px;
`

const HeroSection = ({
                       heading = null,
                       image = {},
                       buttonUrl,
                       buttonText,
                       video = {},
                       text = ""
                     }) => {
  const contentRef = useRef(null)

  const marginTop = useResponsiveValue(
    {
      md: "80px",
      lg: "2rem"
    },
    "20px"
  )

  return (
    <StyledContainer removeVerticalSpacing
                     containerProps={{ style: { marginTop, marginBottom: "var(--section-spacing)" } }}>
      <Composition
        areas={`
        image
        content
        `}
        templateCols={"1fr"}
        areasMd={`content image`}
        templateColsMd={"6fr 6fr"}
        templateColsLg={"5fr 7fr"}
        gap={gap}
      >
        {(Areas) => (
          <>
            <Areas.Content as={StyledContent}>
              <div ref={contentRef} style={{ position: "relative" }}>
                <div style={{ position: "relative" }}>
                  {heading}
                  {text}
                  {buttonUrl && buttonText &&
                  <Button to={buttonUrl?.url} target={buttonUrl?.target} primary>{buttonText}</Button>
                  }
                </div>
              </div>
            </Areas.Content>

            {image.image &&
              <Areas.Image as={StyledImage} style={{ position: "relative" }}>
                <Image
                  style={{ clipPath: "var(--angled-clip-path)" }}
                  gatsbyImageProps={image}
                  direction={"right"}
                />
                <StyledAngles>
                  <StyledBlueAngle />
                  <StyledGoldenAngle />
                </StyledAngles>
              </Areas.Image>
            }
          </>
        )}
      </Composition>
    </StyledContainer>
  )
}

export default HeroSection
